"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLocale = void 0;
var AppLocale;
(function (AppLocale) {
    AppLocale["en"] = "en";
    AppLocale["pl"] = "pl";
})(AppLocale || (exports.AppLocale = AppLocale = {}));
